
import Vue from 'vue'
import FastClick from 'fastclick'
import router from './router'
import App from './App'
import VueCookies from 'vue-cookies'
import api from './api/api.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'



Vue.use(ToastPlugin)
Vue.use(VueCookies)
Vue.use(ConfirmPlugin)
Vue.use(AlertPlugin)
Vue.prototype.$api = api
FastClick.attach(document.body)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
router,
render: h => h(App)
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js